
class UI {


    /**
     * Put your code for jquery $(document).ready() function
     */

    ready() {
        let $body = $("body");
        let menuIn = new TimelineMax({paused:true});

        menuIn.fromTo($('#menu-holder'), 0, {zIndex: -1}, {zIndex: 100})
            .to($('.menu'), 0.1, {backgroundColor: "#fff", ease: Power2.easeInOut})
            .staggerTo($('.menu-card'), 0.1, { opacity: 1, y: '0', ease: Power2.easeInOut}, 0.1)
            .reverse();

        //modal open fix - add class modal open to make sure that the ipad don't lose focus
        $(document).on('hidden.bs.modal', (event) => {
          if ($('.modal:visible').length) {
            $body.addClass('modal-open');
          }
        });

        $('#menu-toggler').on('click', (event) => {
            $('.burger-toggle').toggleClass('active');
            menuIn.reversed() ? menuIn.play() : menuIn.reverse(0.1);
        });
    }


    /**
     * Put your code for jquery $(window).load() function
     */
    loaded() {
        if(! $("#payment-steps").length) {
            // Select all links with hashes
            $('a[href*="#"]')
              // Remove links that don't actually link to anything
              .not('[href="#"]')
              .not('[href="#0"]')
              .not('[href="#next"]') //disable on step.js links
              .not('[href="#previous"]') //disable on step.js links
              .not('[href="#finish"]') //disable on step.js links
              .not('[href*="modal"]')
              .not('[href^="#heading"]') //disable on bootstrap accordions
              .not('[href^="#collapse"]') //disable on bootstrap accordions
              .click(function(event) {
                // On-page links
                if (
                  location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                  &&
                  location.hostname == this.hostname
                ) {
                  // Figure out element to scroll to
                  var target = $(this.hash);
                  target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                  // Does a scroll target exist?
                  if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                      scrollTop: target.offset().top
                    }, 1000, function() {
                      // Callback after animation
                      // Must change focus!
                      var $target = $(target);
                      $target.focus();
                      if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                      } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                      };
                    });
                  }
                }
              });
        }

        // Code to animate the homepage sidebar if an element is into view
        // Call the function only if the sidebar exist
        //Call the function on load and when the user is scrolling
        if($("#home-sidebar").length) {
            toggleClassElemView($("#hero-home"), $(".sidebar-link[href='#hero-home']"));
            toggleClassElemView($("#home-brand"), $(".sidebar-link[href='#home-brand']"));
            toggleClassElemView($("#home-list"), $(".sidebar-link[href='#home-list']"));
            toggleClassElemView($("#blog-featured"), $(".sidebar-link[href='#blog-featured']"));
            toggleClassElemView($("#search-section"), $(".sidebar-link[href='#search-section']"));
            $( window ).scroll(function() {
                toggleClassElemView($("#hero-home"), $(".sidebar-link[href='#hero-home']"));
                toggleClassElemView($("#home-brand"), $(".sidebar-link[href='#home-brand']"));
                toggleClassElemView($("#home-list"), $(".sidebar-link[href='#home-list']"));
                toggleClassElemView($("#blog-featured"), $(".sidebar-link[href='#blog-featured']"));
                toggleClassElemView($("#search-section"), $(".sidebar-link[href='#search-section']"));
            });
        }

        // check if the link is on its element (the link have fixed position)
        function linkIsOnActiveSection(element, link) {
            var fixed_position = link.offset().top;
            var fixed_height = link.outerHeight();

            var toCross_position = element.offset().top;
            var toCross_height = element.outerHeight();

            if (fixed_position + fixed_height  < toCross_position) {
                return false;
            } else if (fixed_position > toCross_position + toCross_height) {
                return false;
            } else {
                return true;
            }
        }

        //toggle the class active if link link is on the element or not
        function toggleClassElemView(element, link) {
            if(linkIsOnActiveSection(element, link)) {
                link.addClass("active");
            }
            else {
                link.removeClass("active");
            }
        }

        //make errors page full height and remove footer
        if($(".error-section").height()) {
            $(".footer").hide();
            resizeError();

            $(window).resize(function () {
                resizeError();
            });
        }

        function resizeError() {
            var viewHeight = $(window).height();
            var menuHeight = $("#nav").innerHeight();

            if(viewHeight - menuHeight > 395) {
                $(".error-section").height(viewHeight - menuHeight);
            }
            else {
                $(".error-section").height(395);
            }
        }
    }
}

export default new UI();